import reactComponentLoader from 'scripts/react-component-loader'

import App from './App'
import { parsedItemsNewMyAccount } from './utils'

export type AppProps = {
  itemsMyAccount: string
}

const AppWithProps = ({ itemsMyAccount }: AppProps) => {
  const itemsMenu = parsedItemsNewMyAccount(itemsMyAccount)

  return (
    <App itemsMyAccount={itemsMenu} />
  )
}

reactComponentLoader(AppWithProps, '[data-page-my-account]')
